import { combineReducers } from "redux";
import omopReducer from "./omop";

export default combineReducers({
  omop: omopReducer,
});
